
// StatusConfig.js - Configurações e utilitários para status de processos

export const PROCESSO_STATUS = {
  INICIAL: 'inicial',
  EM_ANDAMENTO: 'em_andamento', 
  CONCLUIDO: 'concluido'
};

export const STATUS_CONFIG = {
  [PROCESSO_STATUS.INICIAL]: {
    label: 'Inicial',
    color: 'blue',
    bgColor: 'bg-blue-50',
    textColor: 'text-blue-700',
    borderColor: 'border-blue-200',
    icon: 'DocumentPlusIcon',
    description: 'Processo recém-criado, aguardando desenvolvimento'
  },
  [PROCESSO_STATUS.EM_ANDAMENTO]: {
    label: 'Em Andamento',
    color: 'yellow',
    bgColor: 'bg-yellow-50',
    textColor: 'text-yellow-700',
    borderColor: 'border-yellow-200',
    icon: 'CogIcon',
    description: 'Processo em desenvolvimento ativo'
  },
  [PROCESSO_STATUS.CONCLUIDO]: {
    label: 'Concluído',
    color: 'green',
    bgColor: 'bg-green-50',
    textColor: 'text-green-700',
    borderColor: 'border-green-200',
    icon: 'CheckCircleIcon',
    description: 'Processo finalizado com sucesso'
  }
};

export const STATUS_TRANSITIONS = {
  [PROCESSO_STATUS.INICIAL]: [PROCESSO_STATUS.EM_ANDAMENTO],
  [PROCESSO_STATUS.EM_ANDAMENTO]: [PROCESSO_STATUS.INICIAL, PROCESSO_STATUS.CONCLUIDO],
  [PROCESSO_STATUS.CONCLUIDO]: [PROCESSO_STATUS.EM_ANDAMENTO]
};

export const getStatusConfig = (status) => {
  return STATUS_CONFIG[status] || STATUS_CONFIG[PROCESSO_STATUS.INICIAL];
};

export const canTransitionTo = (fromStatus, toStatus) => {
  return STATUS_TRANSITIONS[fromStatus]?.includes(toStatus) || false;
};

export const getNextStatuses = (currentStatus) => {
  return STATUS_TRANSITIONS[currentStatus] || [];
};

export const validateStatusTransition = (fromStatus, toStatus, tasks = []) => {
  // Verificar se transição é permitida
  if (!canTransitionTo(fromStatus, toStatus)) {
    return {
      valid: false,
      reason: `Transição de ${getStatusConfig(fromStatus).label} para ${getStatusConfig(toStatus).label} não é permitida`
    };
  }

  // Validação especial para CONCLUÍDO
  if (toStatus === PROCESSO_STATUS.CONCLUIDO) {
    const incompleteTasks = tasks.filter(task => !task.completed);
    if (incompleteTasks.length > 0) {
      return {
        valid: false,
        reason: `Não é possível concluir o processo: ${incompleteTasks.length} tarefa(s) pendente(s)`
      };
    }
  }

  return { valid: true };
};
